module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-36.c36c5367.png";